module.exports = __webpack_public_path__ + "static/media/avatar-marco.457da313.png";